import Component from './LoginAnimation.vue';

export default Component;
